import apiApp from "./index";
const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

const getHeaders = () => {
    const headers = {
        Authorization: `Bearer ${token}`,
        "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };

    if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
        headers["tenant-login"] = true;
    }

    return headers;
};

const getSubTenantDTO = () => {
    return decodedToken?.isMultitenancy && decodedToken?.subTenantId
        ? { id: decodedToken.subTenantId }
        : null;
};

const StorageSensorApi = {
    // Create Sensors Api
    CreateSensors: (data) => {
        const subTenantIds = decodedToken?.subTenantIds?.split(',');

        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        return new Promise((resolve, reject) => {
            apiApp
                .post(`/storage-sensors`, data, {
                    headers: getHeaders(),
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },
    // Put Sensors Api
    PutSensors: (SensorsID, data) => {
        const subTenantIds = decodedToken?.subTenantIds?.split(',');

        const jsonData = JSON.parse(data);
        const subTenantDTO = getSubTenantDTO();
        if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;

        return new Promise((resolve, reject) => {
            apiApp
                .put(`/storage-sensors/${SensorsID}`, data, {
                    headers: getHeaders(),
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // Single Sensors Api
    SingleSensors: (SensorsID) => {
        return new Promise((resolve, reject) => {
            apiApp
                .get(
                    `/storage-sensors/${SensorsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    {
                        headers: getHeaders(),
                    }
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // List Sensors Api
    ListSensors: () => {
        return new Promise((resolve, reject) => {
            apiApp
                .get(`/storage-sensors?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
                    headers: getHeaders(),
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

    // Delete Sensors Api
    DeleteSensors: (SensorsID) => {
        return new Promise((resolve, reject) => {
            apiApp
                .delete(
                    `/storage-sensors/${SensorsID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
                    {
                        headers: getHeaders(),
                    }
                )
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data);
                });
        });
    },

};

export default StorageSensorApi;
